<div [formGroup]="formGroup">
  <cap-textarea formControlName="answer_text"></cap-textarea>
</div>
